<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="costingData?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + costingData?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="costingData?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${costingData?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!costingData?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ costingData?.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ costingData?.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ costingData?.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ costingData?.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${costingData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">Import Costing</h2>
                      </div>
                    </td>
                  </tr>

                   <!-- 'other_bank_charge' => $request->other_bank_charge,
                'warehouse_charge' => $request->warehouse_charge,
                'delivery_man_charge' => $request->delivery_man_charge,
                'distribution_cost' => $request->distribution_cost,
                'insurance' => $request->insurance,
                'transportation_cost' => $request->transportation_cost,
                'loading_unloading_cost' => $request->loading_unloading_cost,
                'c_and_f_expanse' => $request->c_and_f_expanse,
                'customs_duty' => $request->customs_duty,
                'total_other_expanse' => $request->total_other_expanse,
                'total_lc_value' => $request->total_lc_value,
                'total_expanse' => $request->total_expanse, -->

                  <tr>
                    <td colspan="100%" class="details-table">
                      <table  class="dep-table mt-5" style="width:20%">
                        <tbody>
                            <tr>
                              <th class="text-left">Other Bank Charge</th>
                              <th>{{ costingData?.other_bank_charge }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Warehouse Charge</th>
                              <th>{{ costingData?.warehouse_charge }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Delivery Man</th>
                              <th>{{ costingData?.delivery_man_charge }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Distribution Cost</th>
                              <th>{{ costingData?.distribution_cost }}</th>
                            </tr>
                             <tr>
                              <th class="text-left">Insurance</th>
                              <th>{{ costingData?.insurance }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Transportation</th>
                              <th>{{ costingData?.transportation_cost }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Loding & Unloding</th>
                              <th>{{ costingData?.loading_unloading_cost }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">C & F Expenses</th>
                              <th>{{ costingData?.c_and_f_expanse }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Customs Duty</th>
                              <th>{{ costingData?.customs_duty }}</th>
                            </tr>

                            <tr>
                              <th class="text-left">Total Other Expanse</th>
                              <th>{{ costingData?.total_other_expanse  }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Total LC value</th>
                              <th>{{ costingData?.total_lc_value  }}</th>
                            </tr>
                            <tr>
                              <th class="text-left">Total Expanse</th>
                              <th>{{ costingData?.total_expanse }}</th>
                            </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                
                  <!-- Details table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">

                      <table class="dep-table mt-5" style="width: 100%; border-collapse: collapse;">
                          <thead>
                            <tr>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Sl</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Item Name</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Qty (Kgs)</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Rate/Kg (PI)</th>

                                <th colspan="2" style="border:1px solid #000; padding:4px;">{{ costingData?.currency?.code }} 1 = {{ Number(costingData?.conversion_rate).toFixed(2) }}TK</th>

                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Duty, Ins & BC %</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Duty, Ins & BC</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">LC Cost TK</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Freight Charge</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">LC Cost / Kg</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Profit %</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">Profit</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">AIT %</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">AIT</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">VAT Able Price</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">VAT %</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">VAT</th>
                                <th rowspan="2" style="border:1px solid #000; padding:4px;">With VAT</th>
                            </tr>
                            <tr>
                                <th style="border:1px solid #000; padding:4px;">Total Value</th>
                                <th style="border:1px solid #000; padding:4px;">Value in TK</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in costingData?.details">
                                <td style="border:1px solid #000; padding:4px;">{{ index + 1 }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ detail.product?.name }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.qty).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.rate).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.total_value).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.value_in_tk).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.duty_ind_bc_charge_percent).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.duty_ind_bc_charge).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.lc_cost_in_tk).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.freight_charge).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.lc_cost_per_kg).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.profit_percent).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.profit).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.ait_percent).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.ait).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.vatable_price).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.vat_percent).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.vat).toFixed(2) }}</td>
                                <td style="border:1px solid #000; padding:4px;">{{ Number(detail.with_vat).toFixed(2) }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="2" style="border:1px solid #000; padding:4px;">Total</th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.qty.toFixed(2) }}
                                </th>
                                <th></th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.total_value.toFixed(2) }}
                                </th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.value_in_tk.toFixed(2) }}
                                </th>
                                <th></th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.duty_ind_bc_charge.toFixed(2) }}
                                </th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.lc_cost_in_tk.toFixed(2) }}
                                </th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.freight_charge.toFixed(2) }}
                                </th>
                                <th></th>
                                <th></th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.profit.toFixed(2) }}
                                </th>
                                <th></th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.ait.toFixed(2) }}
                                </th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.vatable_price.toFixed(2) }}
                                </th>
                                <th></th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.vat.toFixed(2) }}
                                </th>
                                <th style="border:1px solid #000; padding:4px;">
                                    {{ grandTotals.with_vat.toFixed(2) }}
                                </th>
                            </tr>
                        </tfoot>
                      </table>

                    </td>
                  </tr>


                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
             
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import formattedDate from "@/plugins/dateFormatter";

const route = useRoute();
const router = useRouter();
const store = useStore();

const id = route.params.id;
const costingData = ref(null);
const invoiceHeader = ref(true);
const pagePadding = ref(0);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Import Costing</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        } 
  
        html, body {  
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
        .details-table {
          padding: 0px 25px;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
        
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
          padding: 0px 30px;
          justify-content:space-between;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 12px 6px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        
        ${printContent}
        
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

const grandTotals = computed(() => {
  const details = costingData.value?.details || [];

  const sum = (key) => details.reduce((total, item) => total + Number(item[key] || 0), 0);
  return {
    qty: sum("qty"),
    total_value: sum("total_value"),
    value_in_tk: sum("value_in_tk"),
    duty_ind_bc_charge: sum("duty_ind_bc_charge"),
    lc_cost_in_tk: sum("lc_cost_in_tk"),
    freight_charge: sum("freight_charge"),
    profit: sum("profit"),
    ait: sum("ait"),
    vatable_price: sum("vatable_price"),
    vat: sum("vat"),
    with_vat: sum("with_vat"),
  };
});

onMounted(async () => { 
  try {
    store.commit("SET_LOADING", { color: "primary" });
    const res =  await store.dispatch("lcImportLcCosting/getLcImportLcCostingById", id);
    store.commit("UNSET_LOADING");

    if (res?.data?.success) {
      costingData.value = res.data.data;
      console.log("Master Sales Contact Data:", costingData.value);
    } else {
      console.error("API returned unsuccessful response:", res);
    }
  } catch (error) {
    console.error("Error fetching sales contact:", error);
    store.commit("UNSET_LOADING");
  }
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
